import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';

import { toBlogCategoryLink } from 'lib/links';

const MainArticlesRelatedCategories = ({ relatedCategories = [] }) => (
  <div className="mt-4 flex px-5 sm:overflow-x-scroll md:flex-wrap md:overflow-x-hidden md:px-0">
    {relatedCategories.map(({ categoryName, categorySlug }) => (
      <NextLink
        key={categorySlug}
        href={toBlogCategoryLink(categorySlug)}
        prefetch={false}
        passHref
      >
        <Button as="a" className="mr-2" size="size3" type="secondary-stroke">
          {categoryName}
        </Button>
      </NextLink>
    ))}
  </div>
);

MainArticlesRelatedCategories.propTypes = {
  relatedCategories: PropTypes.arrayOf(
    PropTypes.shape({
      categoryName: PropTypes.string.isRequired,
      categorySlug: PropTypes.string.isRequired,
    })
  ),
};

export default MainArticlesRelatedCategories;
